// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2QZbf","errorLogs":"styles_errorLogs__c2Uo1"};